import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda detailu jobu (strom kroků s průběhem). Standardní agenda okno s parametrem runId —
 * otevírá se osamostatněně po startu jobu, z „Detail" v přehledu i z toast akce; po F5 se obnoví
 * z URL a stav si dofetchne z API.
 */
export const jobDetailAgenda = defineAgenda({
  id: 'app.jobs.detail',
  path: 'app/jobs/detail',
  open: {
    runId: param.uuid(),
  },
  title: 'Detail jobu',
  icon: 'list',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
